import React from 'react';
import bem from 'utils/bem';
import { formatDurationMillis, formatDurationSeconds } from 'utils/time';

export const selectorBlock = bem('clip-selector');
export const introBlock = bem('clip-select-intro');
export const pageBlock = bem('clip-select-page');
export const headerBlock = bem('clip-select-header');
export const ctaBlock = bem('clip-cta-button');
export const captionsModalBlock = bem('add-clip-captions-modal');
export const clipSelectVideoClipper = bem('clip-select-video-clipper');

type CreateClipNameResultType = 'element' | 'string';

export type CreateClipNameOptions<
  TResult extends CreateClipNameResultType = CreateClipNameResultType
> = {
  as: TResult;
};

export function createClipName(
  suggestionIndex: number,
  startMillis: number,
  endMillis: number,
  opts: CreateClipNameOptions<'string'>,
): string;
export function createClipName(
  suggestionIndex: number,
  startMillis: number,
  endMillis: number,
  opts?: CreateClipNameOptions<'element'>,
): JSX.Element;
export function createClipName(
  suggestionIndex: number,
  startMillis: number,
  endMillis: number,
  opts?: CreateClipNameOptions,
): JSX.Element | string {
  const startTime = formatDurationMillis(startMillis, {
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
    trim: false,
  });

  const endTime = formatDurationMillis(endMillis, {
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
    trim: false,
  });

  const duration = formatDurationSeconds(
    Math.floor((endMillis - startMillis) / 1000),
    {
      asSeconds: true,
    },
  );

  const clipIndex = suggestionIndex + 1;
  const clipNumber = clipIndex < 10 ? `0${clipIndex}` : String(clipIndex);

  return !opts?.as || opts.as === 'element' ? (
    <>
      Clip #{clipNumber} {startTime}-{endTime}
      <br />({duration})
    </>
  ) : (
    `Clip #${clipNumber} ${startTime}-${endTime} (${duration})`
  );
}
